export default __webpack_public_path__ + "static/media/assessment_glide_5_1.f9d4b5bb.svg";